<template>
  <div class="order-total">
    <div class="order-total__recap">
      <p class="order-total__terms">
        Procedendo con l'acquisto accetti integralmente le
        <router-link class="order-total__link" :to="{ name: 'terms' }">Condizioni generali di uso e vendita</router-link>.
        L'acquisto sarà completato solo con la conferma di erogazione dal portale welfare.
        Prendi visione della nostra
        <a class="order-total__link" :href="site.urlPrivacy" target="_blank">Informativa sulla privacy</a>
        e dei
        <router-link class="order-total__link" :to="{ name: 'terms' }">Termini e le condizioni</router-link>
        delle Gift Card VadoBay.
      </p>
    </div>

    <!-- prodotto e taglio sono già nello store: alla CTA resta la sola navigazione -->
    <vb-button
      class="order-total__cta"
      :vb_options="{
        text: `<strong>${cta_text}</strong>`,
        to: { name: 'checkout' },
        icon: 'g-card',
        variant: 'info',
        size: 'lg',
        disabled: !selected_amount,
      }"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { checkout_cta_label } from '@livegift/resources';

  export default {
    name: 'order-total',

    data() {
      return {
        site: this.$config.site,
      };
    },

    computed: {
      ...mapState('livegift', ['selected_amount']),

      cta_text() {
        return checkout_cta_label(this.selected_amount);
      },
    },
  };
</script>

<style lang="scss" scoped>

  // barra riepilogo: card a sé, più stretta di raggio e con ombra rispetto ai pannelli di pagina
  .order-total {
    display: flex;
    align-items: center;
    padding: $grid-gutter-width;
    background-color: $white;
    border-radius: $border-radius-lg * 3;
    box-shadow: 0 10px 7.5px rgba($black, .1);

    &__terms {
      margin: 0;
      font-size: $font-size-sm;
      color: $gray-600;
      line-height: normal;
    }

    &__link {
      color: $info;
      text-decoration: underline;
    }

    &__cta {
      margin-left: $grid-gutter-20;
      display: flex;
      flex-basis: 100%;
      align-items: center;
      justify-content: center;

      @include media-breakpoint-up(xl) {
        flex-basis: 45%;
      }

      @include livegift-cta-icon;
    }

    @include media-breakpoint-down(md) {
      display: block;

      &__cta {
        margin: $grid-gutter-20 0 0;
      }
    }
  }
</style>